module.exports = __webpack_public_path__ + "files/b270053d7284c386fe5d521ac88cee23.png";